/* eslint-disable */
import React from 'react'
import Accordion from '../../components/accordion'
import Sidebar from './sidebar-syarat-umum'
import { Col } from 'react-flexbox-grid'
import styled from 'styled-components'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'

const HelpPageStyle = styled.div`
  @media screen and (min-width: 300px) and (max-width: 700px) {
    .sidebar-help-custom-navigation {
      width: 100% !important;
      margin-bottom: 20px;
    }

    .sidebar-help-custom-content {
      width: 100% !important;
      padding-left: 0 !important;
    }
  }
`

const TermAndCondition = () => {
  const { t } = useTranslation()
  const data = [
    {
      title: t('pageSyaratUmum.part1'),
      number: 1,
      targetScroll: 'syarat-umum-1',
      desc: t('pageSyaratUmum.part2')
    },
    {
      title: t('pageSyaratUmum.part3'),
      number: 2,
      targetScroll: 'syarat-umum-2',
      desc: t('pageSyaratUmum.part4')
    },
    {
      title: t('pageSyaratUmum.part5'),
      number: 3,
      targetScroll: 'syarat-umum-3',
      desc: t('pageSyaratUmum.part6')
    },
    {
      title: t('pageSyaratUmum.part7'),
      number: 4,
      targetScroll: 'syarat-umum-4',
      desc: t('pageSyaratUmum.part8')
    },
    {
      title: t('pageSyaratUmum.part9'),
      number: 5,
      targetScroll: 'syarat-umum-5',
      desc: t('pageSyaratUmum.part10')
    },
    {
      title: t('pageSyaratUmum.part11'),
      number: 6,
      targetScroll: 'syarat-umum-6',
      desc: t('pageSyaratUmum.part12')
    },
    {
      title: t('pageSyaratUmum.part13'),
      number: 7,
      targetScroll: 'syarat-umum-7',
      desc: t('pageSyaratUmum.part14')
    },
    {
      title: t('pageSyaratUmum.part15'),
      number: 8,
      targetScroll: 'syarat-umum-8',
      desc: t('pageSyaratUmum.part16')
    },
    {
      title: t('pageSyaratUmum.part17'),
      number: 9,
      targetScroll: 'syarat-umum-9',
      desc: t('pageSyaratUmum.part18')
    },
    {
      title: t('pageSyaratUmum.part19'),
      number: 10,
      targetScroll: 'syarat-umum-10',
      desc: t('pageSyaratUmum.part20')
    },
    {
      title: t('pageSyaratUmum.part21'),
      number: 11,
      targetScroll: 'syarat-umum-11',
      desc: t('pageSyaratUmum.part22')
    },
    {
      title: t('pageSyaratUmum.part23'),
      number: 12,
      targetScroll: 'syarat-umum-12',
      desc: t('pageSyaratUmum.part24')
    }
  ]

  return (
    <div style={{ width: '100%' }}>
      <HelpPageStyle>
        <Helmet>
          <title>Syarat Umum | halojasa.com</title>
          <meta charSet="utf-8" />
          <meta
            name="description"
            content="Syarat umum halo jasa, baca syarat umum halo jasa di halaman ini"
          />
          <meta property="og:title" content="Syarat umum | halojasa.com" />
          <meta property="og:site_name" content="Halo Jasa" />
          <meta
            property="og:description"
            content="Syarat umum halo jasa, baca syarat umum halo jasa di halaman ini"
          />
          <meta
            property="og:url"
            content="https://halojasa.com/bantuan/syarat-umum/"
          />
          <meta
            property="og:image"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
          />
          <meta
            property="og:image:secure_url"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
          />
          <meta property="og:image:type" content="image/png" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta
            property="og:image"
            itemProp="image"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-sq.png"
          />
          <meta
            property="og:image:secure_url"
            itemProp="image"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-sq.png"
          />
          <meta property="og:image:type" content="image/png" />
          <meta property="og:image:width" content="300" />
          <meta property="og:image:height" content="300" />
          <meta property="og:type" content="website" />
          <meta property="fb:app_id" content="951866408583742" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@pthalojasa" />
          <meta name="twitter:title" content="Syarat umum | halojasa.com" />
          <meta
            name="twitter:description"
            content="Syarat umum halo jasa, baca syarat umum halo jasa di halaman ini"
          />
          <meta
            name="twitter:image:src"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
          />
          <meta
            name="p:domain_verify"
            content="4e6fcb4deba1a02d84225fad69babc0b"
          />
          <meta name="keyword" content="syarat umum" />
          <link
            rel="canonical"
            href="https://halojasa.com/bantuan/syarat-umum/"
          />
        </Helmet>
        <Col
          style={{
            width: '350px',
            display: 'inline-block',
            verticalAlign: 'top'
          }}
          className="sidebar-help-custom-navigation"
        >
          <Sidebar />
        </Col>

        <Col
          style={{
            width: 'calc(100% - 350px)',
            display: 'inline-block',
            verticalAlign: 'top',
            boxSizing: 'border-box',
            paddingLeft: '20px'
          }}
          className="sidebar-help-custom-content"
        >
          {data.map(item => {
            return (
              <Accordion key={item.number} {...item} withNumber></Accordion>
            )
          })}
        </Col>
      </HelpPageStyle>
    </div>
  )
}

export default TermAndCondition
